export const triggerFileInput = (id: string) => {
  const fileInput = document.getElementById(id) as HTMLInputElement | null;
  if (fileInput) {
    fileInput.click();
  }
};
